import { READING_MEASURE } from "@elyxeer/ui";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

/**
 * The health disclaimer every content page closes on — articles, videos, protocols,
 * webinar recordings and events alike.
 *
 * The wording is one catalogue key (`common.contentDisclaimer`), so a change from
 * counsel lands everywhere at once. It sits *after* the page's content rather than in
 * a dialog: it has to be present on every page without ever standing between the
 * member and what they opened. Small and muted, but on the `T3` step and a text tier
 * the contrast guard holds to AA, so it stays legible.
 *
 * The Czech copy binds one-letter words to the word after them with no-break spaces
 * (`a\u00a0vzdělávací`), as Czech typesetting requires; keep them when the text changes.
 */
export function ContentDisclaimer() {
  const { t } = useTranslation();

  return (
    <Box
      component="footer"
      data-testid="content.disclaimer"
      sx={{
        maxWidth: READING_MEASURE,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        marginTop: { xs: 2, md: 3 },
      }}
    >
      <Divider />
      <Typography variant="T3" sx={{ color: "text.muted" }}>
        {t("common.contentDisclaimer")}
      </Typography>
    </Box>
  );
}
